import { Component, OnInit } from '@angular/core';
import { MatchService } from '../match.service';
import swal from "sweetalert2";

@Component({
  selector: 'app-match',
  templateUrl: './match.component.html',
  styleUrls: ['./match.component.css']
})
export class MatchComponent implements OnInit {
  matchList: any;
  match: any;
  isLoading = false;
  //isAlert = false;
  constructor(private matchService: MatchService) { }

  ngOnInit() {
    this.isLoading = true;
    this.matchService.getAllMatch().subscribe(response => {
      let cricket = response['result'];
      this.matchList = this.getCricketMatch(cricket);
      this.isLoading = false;
      //console.log(this.matchList);
    },
      error => {
        //console.log(error);
        this.isLoading = false;
      });

    this.matchService.getAllMatches();
    this.matchService.getUpdateAllMatchListner()
      .subscribe((response) => {
        //console.log(response);
        this.match = response.allMatch;
      },
        error => {
          console.log(error);
        });
  }

  getCricketMatch(cricket) {
    return cricket.filter(e => {
      return e.sport_id === '4';
    })
  }

  addMatch(data, inc) {
    //console.log(data.event_id);
    let btn = (<HTMLInputElement>document.getElementById('btn' + inc)); 4
    btn.disabled = true;
    let res = this.checkExists(data.event_id);
    if (!res) {
      this.matchService.createMatch(data).subscribe((response) => {
        btn.innerText = 'Added';
        btn.classList.remove("btn-danger");
        btn.classList.add("btn-success");
        //console.log(response);
        //this.isAlert = true;
        this.msgSuccess();
      }, error => {
        btn.disabled = false;
        this.msgFailure();
      });
    }
  }

  checkExists(eventId) {
    if (this.match) {
      return this.match.some(x => x.eventId === eventId)
    }
    return false;
  }

  actionTitle(eventId) {
    if (this.match) {
      if (this.match.some(x => x.eventId === eventId)) {
        return 'Added';
      }
      else {
        return 'Add';
      }
    }
    return 'Add';
  }

  showColor(eventId) {
    if (this.match) {
      if (this.match.some(x => x.eventId === eventId)) {
        return 'success';
      }
      else {
        return 'danger';
      }
    }
    return 'danger';
  }

  msgSuccess() {
    swal.fire({
      icon: 'success',
      title: 'Successfully Added!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  msgFailure() {
    swal.fire({
      icon: 'error',
      title: 'Something Went Wrong!',
      showConfirmButton: false,
      timer: 1500
    })
  }
}